import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { analytics } from 'helpers'
import config from 'config'

import EllipsisIcon from 'components/EllipsisIcon'
import OutsideAlerter from 'components/OutsideAlerter'
import EmptyState from './EmptyState'

const MoreOptions = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <OutsideAlerter clickedOutside={() => setIsOpen(false)}>
      <div className="absolute top-6 right-3 lg:right-10">
        <div className="flex flex-col items-end outline-none overflow-visible w-5" tabIndex="1">
          <button
            className="bg-transparent transform rounded-full flex justify-center items-center h-7 w-7 lg:bg-black lg:rotate-90 lg:bg-opacity-20"
            onClick={e => {
              // prevents the click event from bubbling up to the event card link
              e.preventDefault()
              setIsOpen(!isOpen)
            }}
          >
            <EllipsisIcon className="h-4 w-3" />
          </button>
          {isOpen && (
            <button
              className="flex bg-white w-36 mt-4 text-black text-sm text-center p-2 px-4 z-30"
              onClick={e => {
                // prevents the click event from bubbling up to the event card link
                e.preventDefault()
                window.open(config.help_page_url, '_blank')
                setIsOpen(false)
                analytics.segmentTrack('User Clicked Help Center')
              }}
            >
              Need more help?
            </button>
          )}
        </div>
      </div>
    </OutsideAlerter>
  )
}

EmptyState.propTypes = {
  user: PropTypes.object,
}

export default MoreOptions
